<template>
  <el-drawer v-model="visible" :title="title" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close size="60%">
    <el-form :model="role" ref="roleForm" :rules="rules" label-width="120px">
      <el-form-item label="角色名称：" prop="name">
        <el-input v-model="roleData.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="启用：">
        <el-switch active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" v-model="roleData.isEffective"
          inline-prompt disabled></el-switch>
      </el-form-item>
    </el-form>

    <el-checkbox-group v-model="selectedIds">
      <table class="role-edit-table" v-for="item in powerAll" :key="item.name">
        <thead><tr><th colspan="2">{{item.name}}</th></tr></thead>
        <tbody>
          <tr v-for="power in item.value" :key="power.id">
            <td style="width: 150px;">
              <el-checkbox :label="power.id">{{power.name}}</el-checkbox>
            </td>
            <td>
              <template v-for="subPower in power.children" :key="subPower.id">
                <div class="power-sub-row"><el-checkbox :label="subPower.id">{{subPower.name}}</el-checkbox></div>
                <div class="power-grant-sub-row" v-if="subPower.children && subPower.children.length">
                  <el-checkbox v-for="grandSubPower in subPower.children" :key="grandSubPower.id" :label="grandSubPower.id">{{grandSubPower.name}}</el-checkbox>
                </div>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </el-checkbox-group>

    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false" v-loading="saveLoading">取消</el-button>
        <el-button type="primary" @click="save" v-loading="saveLoading">提交</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import {powerAllGroup, getPowerIdsByRoleId, saveRolePower } from '@/api/sys/role';
import { deepClone, objArrayToTree } from '@/utils/common';
import { defineComponent } from 'vue'

export default defineComponent({
  emits: ['get-data'],
  props: { orgs: Array },
  data() {
    return {
      title: null,
      visible: false,
      saveLoading: false,
      roleData: {
        id: null,
        name:'',
        type:'',
        isEffective:1,
      },
      
      powerAll: [
        { name: '平台', value: [] },
        { name: 'PC端', value: [] },
        { name: '小程序', value: [] }
      ],
      selectedIds: [],
      orgProps: {
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'fullName'
      }
    }
  },
  computed: {
    orgTree() {
      return objArrayToTree(this.orgs);
    }
  },
  methods: {
    show(row) {
      this.title = '角色授权';
      if(row){
        this.roleData = row ;
      }
      this.selectedIds = []
      this.getPowerAll();
      this.getRolePowerIds();
      this.visible = true;
    },
    getPowerAll() {
      powerAllGroup(this.roleData).then(({data}) => {
        console.log("data",data);
        if(data.data['1'] && data.data['1'].length>0){
           this.powerAll= [
              { name: '平台', value: [] },
            ];
           this.powerAll[0].value = objArrayToTree(data.data['1'] || [], 'id', 'pId');
        }else{
          this.powerAll= [
              { name: 'PC端', value: [] },
              { name: '小程序', value: [] }
            ];
          this.powerAll[0].value = objArrayToTree(data.data['2'] || [], 'id', 'pId');
          this.powerAll[1].value = objArrayToTree(data.data['12'] || [], 'id', 'pId');
        }
      })
    },
    getRolePowerIds() {
      if (!this.roleData.id) {
        return;
      }
      getPowerIdsByRoleId(this.roleData.id).then(({data}) => {
        this.selectedIds = data.data;
      });
    },
    save() {
      this.$confirm('确定保存角色 <'+this.roleData.name+'> 的授权信息？', '提示').then(_ => {
        this.saveLoading = true;
          saveRolePower({ role: this.roleData, powerIds: this.selectedIds}).then(({data}) => {
            if (data.status) {
              this.$message.success(data.msg);
              this.visible = false;
            } else {
              this.$message.warning(data.msg);
            }
            this.saveLoading = false;
          }).catch(_ => this.saveLoading = false);
      }).catch(_ => {})
      
    }
  }
})
</script>

<style lang="scss" scoped>
.role-edit-table {
  width: 100%;
  border-spacing: 0;
  thead, tbody {
    tr {
      th, td {
        border: 1px solid #eee;
        padding: 5px 10px;
        border-top: 0;
        .power-sub-row {
          background: rgb(239,247,253);
          padding: 0 10px;
          border-radius: 3px;
          margin-bottom: 3px;
        }
        .power-grant-sub-row {
          padding: 0 10px;
        }
      }
    }
  }
  thead {
    tr {
      th {
        background-color: #eee;
        font-size: 16px;
        border-top: 1px solid #eee;
      }
    }
  }
}
</style>